/* ============================================================
   APEX LIFE FITNESS — Shared behavior
   ============================================================ */
(function () {
  // --- Announcement dismiss (persists for session)
  var announce = document.getElementById('announce');
  var announceClose = document.getElementById('announceClose');
  if (announce && sessionStorage.getItem('apexAnnounceDismissed') === '1') {
    announce.classList.add('hidden');
  }
  announceClose && announceClose.addEventListener('click', function () {
    announce.classList.add('hidden');
    try { sessionStorage.setItem('apexAnnounceDismissed', '1'); } catch (e) {}
  });

  // --- Mobile drawer
  var burger = document.getElementById('burger');
  var drawer = document.getElementById('drawer');
  var drawerClose = document.getElementById('drawerClose');
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    burger && burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    burger && burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
  burger && burger.addEventListener('click', openDrawer);
  drawerClose && drawerClose.addEventListener('click', closeDrawer);
  drawer && drawer.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', closeDrawer);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  // --- Hero staggered fade-in on load
  var heroReveals = document.querySelectorAll('.hero .reveal');
  heroReveals.forEach(function (el, i) {
    var d = parseInt(el.style.getPropertyValue('--d') || i, 10);
    setTimeout(function () { el.classList.add('in'); }, 80 + d * 90);
  });

  // --- IntersectionObserver scroll reveal
  var heroSet = new Set(heroReveals);
  var others = Array.prototype.filter.call(
    document.querySelectorAll('.reveal'),
    function (el) { return !heroSet.has(el); }
  );
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    others.forEach(function (el) { io.observe(el); });
  } else {
    others.forEach(function (el) { el.classList.add('in'); });
  }
})();
